import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTimeFlies(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <circle
        cx={12.292}
        cy={9.791}
        r={5.833}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.459 9.791h2.38m-1.428 3.334h2.381m-2.38-6.667h2.38m7.708.834v2.58l1.667 1.587"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTimeFlies);
export default ForwardRef;
